import { useStreamSet } from "../../Hooks/Features/Inspectra/useStreamSet";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Dialog } from 'primereact/dialog';
import DatePicker from "react-multi-date-picker";
import { SkeletonContainer } from "../Loader/Loader.jsx";
import { MultiSelect } from "primereact/multiselect";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateConvert, timePickerMuiCss } from "../../utils/Helper.js";
import { Calendar } from "primereact/calendar";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const StreamSet = ({ projectChanged }) => {

    const { options, showPopup, setShowPopup, popupData, hoveredRange, loader, showFilter, setShowFilter, filterOpts, filterValues, setFilterValues, filterCount, expand, setExpand, time, setTime, handleDateRange, handleApplyFilters, handleDefaultFilters } = useStreamSet({ projectChanged });

    return (
        <div className="inspectra-widget-container p-2">
            <div className="d-flex justify-content-between align-items-center">
                <div className="inspectra-widget-header">Stream-Set Pipeline Status</div>
                <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center" onClick={() => setShowFilter(true)}><span className="inspectra-filter-count">{filterCount}</span>filters</div>
            </div>
            <div className="inspectra-date-string">{dateConvert(filterValues?.date?.from_date, "date-time-months")} - {dateConvert(filterValues?.date?.to_date, "date-time-months")}</div>
            <div className="inspectra-widget-content">
                {loader ? <SkeletonContainer /> :
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                }
            </div>

            <div className="position-absolute bottom-0 end-0 me-1 fs-6 c-pointer" onClick={() => setExpand(true)}>
                <FontAwesomeIcon icon="fa-solid fa-expand" />
            </div>

            <Dialog visible={showFilter} onHide={() => setShowFilter(false)} className="modal-small" draggable={false} header="Stream-Set Pipeline Status Filters">
                <div>
                    <div className="d-flex gap-2 inspectra-calendar">
                        <div className="w50">
                            <div>Date: </div>
                            <div>
                                <DatePicker portal zIndex={99999} value={hoveredRange} onChange={handleDateRange} range rangeHover placeholder="Select Date Range" style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="w45 d-flex gap-2 justify-content-between">
                            <div className="w50">
                                <div>From Time: </div>
                                <TimePicker value={time?.from || null} onChange={(e) => setTime((prev) => ({ ...prev, from: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                            <div className="w50">
                                <div>To Time: </div>
                                <TimePicker value={time?.to || null} onChange={(e) => setTime((prev) => ({ ...prev, to: e }))} sx={{ ...timePickerMuiCss, backgroundColor: "white", margin: "2px 2px" }}
                                    slotProps={{
                                        textField: {
                                            label: undefined,
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="w50">
                            <div>Pipeline:</div>
                            <MultiSelect options={filterOpts?.pipeline} placeholder="Pipeline" value={filterValues?.pipeline} onChange={(e) => setFilterValues((prev) => ({ ...prev, pipeline: e.target.value }))} panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'pipeline', filterValues?.pipeline, () => setFilterValues((prev) => ({ ...prev, pipeline: [] })))} filter filterInputAutoFocus />
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <div className="text-primary c-pointer" onClick={() => handleDefaultFilters()}>Select default filters</div>
                        <button className="button btn-primary" onClick={() => handleApplyFilters()}>Apply</button>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={showPopup} onHide={() => setShowPopup(false)} draggable={false} className="modal-large inspectra-grey-dialog" header="Pipeline Issues Details">
                <div>
                    {popupData.map((pipeline) => (
                        <div key={pipeline?._id} className="inspectra-popup-card">
                            <div className="d-flex mb-1">
                                <div className="w40 fw-bold">Project Name:</div>
                                <div className="w60 text-wrap">{pipeline?.project_name}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w40 fw-bold">Streamsets URL:</div>
                                <div className="w60 text-wrap">
                                    <a href={pipeline?.streamsets} target="_blank" rel="noopener noreferrer">
                                        {pipeline?.streamsets}
                                    </a>
                                </div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w40 fw-bold">Pipeline Name:</div>
                                <div className="w60 text-wrap">{pipeline?.pipelinename}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w40 fw-bold">Status:</div>
                                <div className="w60 text-wrap" style={{ color: pipeline?.status?.toLowerCase()?.includes("stop") ? 'red' : 'green' }}>
                                    <span className="streamset-pipeline-status">{pipeline?.status}</span>
                                </div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w40 fw-bold">Message:</div>
                                <div className="w60 text-wrap">{pipeline?.message}</div>
                            </div>

                            <div className="d-flex mb-1">
                                <div className="w40 fw-bold">Created Date:</div>
                                <div className="w60 text-wrap">{new Date(pipeline?.create_date).toLocaleString()}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </Dialog>

            <Dialog visible={expand} onHide={() => setExpand(false)} className="modal-xlarge" draggable={false} header="Stream-Set Pipeline Status Expanded">
                <div>
                    <div className="text-primary inspectra-cursor inspectra-filter d-flex gap-1 align-items-center justify-content-end" onClick={() => setShowFilter(true)}>
                        <span className="inspectra-filter-count">{filterCount}</span>filters
                    </div>
                    <HighchartsReact className="highcharts-container" highcharts={Highcharts} options={options} containerProps={{
                        style: {
                            height: "99%"
                        }
                    }} />
                </div>
            </Dialog>
        </div>
    )
}

export default StreamSet;